export default "__VITE_ASSET__DpIaJOv8__"